import { IconButton, Menu, MenuItem } from '@mui/material';
import React, { FunctionComponent } from "react";
import { SettingsVertiIcon, SettingsWhiteVerticalIcon } from '../../icon';

interface Props {
	data: any;
	IsTiers?: boolean;
	DisabledIcon?: boolean;
}

const GridOptionsComponent: FunctionComponent<Props> = (props) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				tabIndex={8}
				onClick={handleClick}
			>
				{props.DisabledIcon ? <SettingsVertiIcon /> : props.IsTiers ? <SettingsWhiteVerticalIcon /> : <SettingsVertiIcon />}
			</IconButton>
			<Menu
				// getContentAnchorEl={null}
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				classes={{ paper: "bg-color-header-dropdown box-shadow-none" }}
				className={"mr-2 dialogue-shadow"}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				{props.data.map((btn: any, index: number) => (
					!btn.hide &&
					<MenuItem
						key={`${btn.btnName}-${index}`}
						onClick={() => { btn.onClickbtn(); handleClose() }}
						className={btn.btnColor}
					>
						{btn.btnIcon && <btn.btnIcon className="mr-1 w-2" />}
						<span className={"h4-regular color-menu-list-font-color"}>{btn.btnName}</span>
					</MenuItem>
				))}
			</Menu></div>
	);
}
export default GridOptionsComponent;